import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ProductRequest} from '../../../models/ProductRequest';
import {Store} from '@ngrx/store';
import {AppState} from '../../../state/reducers';
import {GoToProductRequestDetail} from '../../state/actions';
import {interval, takeWhile} from "rxjs";

@Component({
  selector: 'product-request-card',
  templateUrl: './product-request-card.component.html',
  styleUrls: ['./product-request-card.component.scss']
})
export class ProductRequestCardComponent implements OnInit, OnDestroy {
  alive = true;
  @Input() productRequest: ProductRequest | null = null;
  @Input() updating = false;
  refresh = new Date();

  constructor(private store: Store<AppState>) {
  }

  ngOnInit(): void {
    interval(30000).pipe(takeWhile(() => this.alive)).subscribe(() => {
      this.refresh = new Date();
    });
  }

  ngOnDestroy(): void {
    this.alive = false;
  }

  openDetail(): void {
    if (this.productRequest) {
      this.store.dispatch(GoToProductRequestDetail({productRequest: this.productRequest}));
    }
  }
}
